var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.onTabs },
          model: {
            value: _vm.activeNameOne,
            callback: function ($$v) {
              _vm.activeNameOne = $$v
            },
            expression: "activeNameOne",
          },
        },
        _vm._l(_vm.tabsOne, function (tab) {
          return _c("el-tab-pane", {
            key: tab.id,
            attrs: { label: tab.label, name: tab.id },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "260px" } },
            [
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "用户注册时默认选择会员版本",
                      required: "",
                    },
                  },
                  [
                    _c("MultiLanguageInp", {
                      attrs: { "inp-data-j-s-o-n": _vm.list[0].versionDesc },
                      on: {
                        updateInp: function (val) {
                          return (_vm.list[0].versionDesc = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置价格"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[0].status,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[0], "status", $$v)
                          },
                          expression: "list[0].status",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[0].status == 1
                        ? _c("el-input-number", {
                            staticClass: "selfInput item inputWidth",
                            attrs: {
                              min: 0,
                              "controls-position": "right",
                              precision: 2,
                            },
                            model: {
                              value: _vm.list[0].price,
                              callback: function ($$v) {
                                _vm.$set(_vm.list[0], "price", $$v)
                              },
                              expression: "list[0].price",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list[0].status == 1
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.activeNameOne == 0 ? "人民币" : "美元")
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 价格描述（官网斜体展示）"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[0].priceDesc },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[0].priceDesc = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置原价（官网斜体删除线）"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[0].originStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[0], "originStatus", $$v)
                          },
                          expression: "list[0].originStatus",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[0].originStatus == 1
                        ? _c("MultiLanguageInp", {
                            staticClass: "item inputWidth",
                            attrs: {
                              "inp-data-j-s-o-n": _vm.list[0].originPrice,
                            },
                            on: {
                              updateInp: function (val) {
                                return (_vm.list[0].originPrice = val)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 维持时间"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "selfInput item inputWidth",
                        attrs: {
                          min: 0,
                          "controls-position": "right",
                          precision: 0,
                        },
                        model: {
                          value: _vm.list[0].duration,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[0], "duration", $$v)
                          },
                          expression: "list[0].duration",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天")]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 按钮描述"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[0].buttonDesc },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[0].buttonDesc = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [_vm._v("会员文案")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.setContent(0, _vm.list[0].intro)
                            },
                          },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "用户注册时第二选择会员版本",
                      required: "",
                    },
                  },
                  [
                    _c("MultiLanguageInp", {
                      attrs: { "inp-data-j-s-o-n": _vm.list[1].versionDesc2 },
                      on: {
                        updateInp: function (val) {
                          return (_vm.list[1].versionDesc2 = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置价格"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[1].status2,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[1], "status2", $$v)
                          },
                          expression: "list[1].status2",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[1].status2 == 1
                        ? _c("el-input-number", {
                            staticClass: "selfInput item inputWidth",
                            attrs: {
                              min: 0,
                              "controls-position": "right",
                              precision: 2,
                            },
                            model: {
                              value: _vm.list[1].price2,
                              callback: function ($$v) {
                                _vm.$set(_vm.list[1], "price2", $$v)
                              },
                              expression: "list[1].price2",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list[1].status2 == 1
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.activeNameOne == 0 ? "人民币" : "美元")
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 价格描述（官网斜体展示）"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[1].priceDesc2 },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[1].priceDesc2 = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置原价（官网斜体删除线）"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[1].originStatus2,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[1], "originStatus2", $$v)
                          },
                          expression: "list[1].originStatus2",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[1].originStatus2 == 1
                        ? _c("MultiLanguageInp", {
                            staticClass: "item inputWidth",
                            attrs: {
                              "inp-data-j-s-o-n": _vm.list[1].originPrice2,
                            },
                            on: {
                              updateInp: function (val) {
                                return (_vm.list[1].originPrice2 = val)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 维持时间"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "selfInput item inputWidth",
                        attrs: {
                          min: 0,
                          "controls-position": "right",
                          precision: 0,
                        },
                        model: {
                          value: _vm.list[1].duration2,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[1], "duration2", $$v)
                          },
                          expression: "list[1].duration2",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天")]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 按钮描述"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[1].buttonDesc2 },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[1].buttonDesc2 = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [_vm._v("会员文案")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.setContent(1, _vm.list[1].intro2)
                            },
                          },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              _vm._v(" "),
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "用户注册时第三选择会员版本",
                      required: "",
                    },
                  },
                  [
                    _c("MultiLanguageInp", {
                      attrs: { "inp-data-j-s-o-n": _vm.list[2].versionDesc3 },
                      on: {
                        updateInp: function (val) {
                          return (_vm.list[2].versionDesc3 = val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置价格"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[2].status3,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[2], "status3", $$v)
                          },
                          expression: "list[2].status3",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[2].status3 == 1
                        ? _c("el-input-number", {
                            staticClass: "selfInput item inputWidth",
                            attrs: {
                              min: 0,
                              "controls-position": "right",
                              precision: 2,
                            },
                            model: {
                              value: _vm.list[2].price3,
                              callback: function ($$v) {
                                _vm.$set(_vm.list[2], "price3", $$v)
                              },
                              expression: "list[2].price3",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list[2].status3 == 1
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.activeNameOne == 0 ? "人民币" : "美元")
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 价格描述（官网斜体展示）"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[2].priceDesc3 },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[2].priceDesc3 = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 设置原价（官网斜体删除线）"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticClass: "switch item",
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.list[2].originStatus3,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[2], "originStatus3", $$v)
                          },
                          expression: "list[2].originStatus3",
                        },
                      }),
                      _vm._v(" "),
                      _vm.list[2].originStatus3 == 1
                        ? _c("MultiLanguageInp", {
                            staticClass: "item inputWidth",
                            attrs: {
                              "inp-data-j-s-o-n": _vm.list[2].originPrice3,
                            },
                            on: {
                              updateInp: function (val) {
                                return (_vm.list[2].originPrice3 = val)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 维持时间"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "selfInput item inputWidth",
                        attrs: {
                          min: 0,
                          "controls-position": "right",
                          precision: 0,
                        },
                        model: {
                          value: _vm.list[2].duration3,
                          callback: function ($$v) {
                            _vm.$set(_vm.list[2], "duration3", $$v)
                          },
                          expression: "list[2].duration3",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天")]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [
                        _c("i", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(" 按钮描述"),
                      ]),
                      _vm._v(" "),
                      _c("MultiLanguageInp", {
                        staticClass: "item inputWidth",
                        attrs: { "inp-data-j-s-o-n": _vm.list[2].buttonDesc3 },
                        on: {
                          updateInp: function (val) {
                            return (_vm.list[2].buttonDesc3 = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "item" }, [_vm._v("会员文案")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.setContent(2, _vm.list[2].intro3)
                            },
                          },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveInfo },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("memberShip", { ref: "memberShip", on: { saveList: _vm.saveList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }